var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",style:({
    borderStyle: _vm.isAppSquare ? 'none' : 'solid',
  }),on:{"click":function($event){return _vm.itemClick()}}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.info.img}}),_c('div',{staticClass:"rightArea"},[_c('p',{staticClass:"itemTitle"},[_vm._v(_vm._s(_vm.info.title))]),_c('p',{staticClass:"itemDes"},[_vm._v(_vm._s(_vm.info.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }